//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import { Splide } from '@splidejs/splide';

const DefaultSplideConfig = {
    type: 'slide',
    speed: 750,
    perPage: 4,
    perMove: 1,
    arrows: true,
    gap: '2rem',
    padding: { left: '2rem', right: '2rem' },
    breakpoints: {
        1024: {
            perPage: 3,
            padding: {left: '2rem', right: '2rem'},
            gap: '2rem'
        },
        640: {
            perPage: 2,
            padding: {left: '1.5rem', right: '1.5rem'},
        },
        480: {
            perPage: 1,
            padding: {left: '1.5rem', right: '1.5rem'},
        },
    },
}

function closeLightBox(lightbox) {
    lightbox.classList.add('opacity-0');
    lightbox.classList.add('pointer-events-none');
    document.documentElement.classList.toggle('body-lock-scroll-modal');
    setTimeout(() => {
        lightbox.classList.add('hidden');
    }, 300);
}

function openLightBox(lightbox) {
    lightbox.classList.remove('hidden');
    document.documentElement.classList.toggle('body-lock-scroll-modal');
    setTimeout(() => {
        lightbox.classList.remove('opacity-0');
        lightbox.classList.remove('pointer-events-none');
    }, 50);
}

function documentKeydownHandler(event, lightbox, splide) {
    if (!lightbox.classList.contains('hidden')) {
        if (event.key === "Escape") {
            closeLightBox(lightbox);
        }
        else if (event.key === "ArrowRight") {
            splide.go('+1');
        }
        else if (event.key === "ArrowLeft") {
            splide.go('-1');
        }
    }
}

function addSplideNavHandlers(navArrows, splide) {
    for ( let arrow of navArrows ) {
        arrow.addEventListener('click', () => {
            if (arrow.dataset.navigate === '+') {
                splide.go('+1');
            }
            else {
                splide.go('-1');
            }
        });
    }
}

function splideMountedMoveHandler(currentPostCounter, totalSlides, navArrows, splide) {
    if (currentPostCounter) {
        setTimeout(() => {
            currentPostCounter.textContent = (splide.index + 1).toString();
            for (let arrow of navArrows) {
                if (arrow.dataset.navigate === '+' && (splide.index + 1) === totalSlides) {
                    arrow.classList.add('!opacity-20', 'pointer-events-none');
                }
                else if (arrow.dataset.navigate === '+') {
                    arrow.classList.remove('!opacity-20', 'pointer-events-none');
                }

                if (arrow.dataset.navigate === '-' && (splide.index + 1) === 1) {
                    arrow.classList.add('!opacity-20', 'pointer-events-none');
                }
                else if (arrow.dataset.navigate === '-') {
                    arrow.classList.remove('!opacity-20', 'pointer-events-none');
                }
            }
        }, 50);
    }
}

window.addEventListener('load', () => {
    const gallerySplidePanel = document.querySelectorAll('.gallery-panel');
    const availableCarousels = document.querySelectorAll('.splide');
    const cardPanel = document.querySelectorAll('.card-panel-slider');

    if (availableCarousels.length) {
        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            const main = panel.closest('main');
            const galleryThumbnails = panel.querySelectorAll('.gallery-panel-image');
            const lightBoxIndex = panel.dataset.lightboxLoop;
            const lightbox = main.querySelector(`.gallery-panel-lightbox[data-lightbox-loop="${lightBoxIndex}"`)
            const lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            const lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            const totalSlides = Number(panel.querySelector('.gallery-splide').dataset.totalSlides);
            const progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);
            const currentPostCounter = panel.querySelector('.gallery-splide-current-slide');
            const navArrows = panel.querySelectorAll('.splide-nav-arrow');

            if (lightbox) {
                const lbox = new Splide(lightbox.querySelector('.gallery-lightbox-splide'), {
                    type: 'fade',
                    speed: 750,
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                        arrow: 'splide__arrow relative z-5 rounded-l-lg w-14 h-16 p-2 bg-lavalle-onyx-1 bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                        next: 'splide__arrow--next right-0 2xl:-right-16',
                    },
                });

                const gallerySplide = new Splide(panel.querySelector('.gallery-splide'), {
                    ...DefaultSplideConfig,
                    type: 'loop',
                    gap: '.5rem',
                    padding: { left: '0', right: '0' },
                    breakpoints: {
                        1024: {
                            perPage: 3,
                            padding: { left: '0', right: '0' },
                            gap: '.5rem',
                        },
                        640: {
                            perPage: 2,
                            padding: { left: '0', right: '0' },
                        },
                        480: {
                            perPage: 1,
                            padding: { left: '0', right: '0' },
                        },
                    },
                    classes: {
                        arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                        arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 fill-current disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                });

                // Closes lightbox on backdrop/close button press

                lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                lightboxClose.addEventListener('click', () => closeLightBox(lightbox));

                // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'

                document.addEventListener("keydown", (e) => documentKeydownHandler(e, lightbox, lbox));

                // Opens lightbox and navigates carousel to the thumbnail that was pressed

                for ( let thumbnail of galleryThumbnails ) {
                    thumbnail.addEventListener('click', () => {
                        if (thumbnail.dataset.slide.length) {
                            lbox.go(parseInt(thumbnail.dataset.slide));
                        }
                        openLightBox(lightbox);
                    });
                }

                // Updates carousel progress bar width

                lbox.on('mounted move', function () {
                    let end = lbox.Components.Controller.getEnd() + 1;
                    progressBar.style.width = String(100 * (lbox.index + 1) / end) + '%';
                });

                addSplideNavHandlers(navArrows, gallerySplide);

                gallerySplide.on('mounted move', () => splideMountedMoveHandler(currentPostCounter, totalSlides, navArrows, gallerySplide));

                lbox.mount();
                gallerySplide.mount()
                gallerySplide.sync(lbox);
            }
        }
        // END GALLERY PANEL SLIDER

        // START CARD PANEL SLIDER
        for ( const panel of cardPanel ) {
            const totalSlides = parseInt(panel.querySelector('.card-panel-splide').dataset.totalSlides);
            const paginationColor = panel.querySelector('.card-panel-splide').dataset.paginationColor ?? 'bg-black';
            const arrowColor = panel.querySelector('.card-panel-splide').dataset.arrowColor ?? 'fill-black';

            const cardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: true,
                perPage: 3,
                perMove: 1,
                pagination: true,
                autoplay: false,
                gap: '1rem',
                padding: '1.5rem',
                interval: 10000,
                destroy: totalSlides <= 3,
                arrowPath: 'M2.68456 22.7027L30.604 22.7027L17.9866 35.4054C16.9128 36.4865 16.9128 38.1081 17.9866 39.1892C19.0604 40.2703 20.6711 40.2703 21.745 39.1892L39.1946 21.8919C39.1946 21.6216 39.4631 21.3514 39.7315 21.0811C39.7315 20.8108 40 20.5405 40 20C40 19.7297 40 19.1892 39.7315 18.9189C39.4631 18.6487 39.1946 18.3784 39.1946 18.1081L21.745 0.810811C20.6711 -0.27027 19.0604 -0.27027 17.9866 0.810811C16.9128 1.89189 16.9128 3.51351 17.9866 4.59459L30.604 17.2973L2.68456 17.2973C1.07382 17.2973 1.41767e-07 18.3784 0 20C-1.41766e-07 21.6216 1.34228 22.7027 2.68456 22.7027Z',
                classes: {
                    pagination: 'splide__pagination flex justify-center items-center gap-2 w-max !mx-auto pb-2',
                    page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out border border-black' + ' ' + paginationColor,
                    arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 pb-4',
                    arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-green-neon-re disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20' + ' ' + arrowColor,
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1023: {
                        perPage: 2,
                        padding: '1rem',
                        gap: '.5rem',
                        destroy: totalSlides <= 2,
                    },
                    639: {
                        perPage: 1,
                        padding: '1rem',
                        gap: '.5rem',
                        destroy: totalSlides === 1,
                    },
                },
            });

            cardSplide.mount();
        }
        // END CARD PANEL SLIDER
    }
});
